import Vue from 'vue'

Vue.prototype.$lang = Vue.prototype.$cookie.get('lang') ? Vue.prototype.$cookie.get('lang') : (navigator.language || navigator.userLanguage) === 'ko-KR' ? 'KR' : 'EN'
